import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { saveAnalystsSettingsFailed, saveAnalystsSettingsSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import loadAnalystsSettings from './loadAnalystsSettings';

export default function* saveAnalystsSettings(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/analytics-settings`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(saveAnalystsSettingsSuccessful(data));
      yield call(loadAnalystsSettings, {});
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(saveAnalystsSettingsFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(saveAnalystsSettingsFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
